import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {NgrxBusy, withBusy} from 'ngrx-busy';
import {firstValueFrom} from 'rxjs';
import {DevicesClient} from 'shared/clients';
import {SideNavRef} from 'shared/sidenav';

@Component({
  selector: 'app-animations-upload-form',
  templateUrl: './animations-upload-form.component.html',
  styleUrls: ['./animations-upload-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AnimationsUploadFormComponent {
  @ViewChild(NgrxBusy, {static: true}) busy: NgrxBusy;

  form: UntypedFormGroup;
  selectedFile = '';
  uploading = false;

  constructor(
    private readonly sideNavRef: SideNavRef<AnimationsUploadFormComponent>,
    private formBuilder: UntypedFormBuilder,
    private devicesClient: DevicesClient,
    private cdr: ChangeDetectorRef
  ) {
    this.form = this.formBuilder.group({file: [null, Validators.required]});
  }

  setFile(file?: File): void {
    if (!file || this.uploading) return;
    this.selectedFile = file.name;
    this.form.get('file').setValue(file);
    this.form.setErrors(null);
  }

  async save(): Promise<void> {
    const fileControl = this.form.get('file');
    if (this.uploading || fileControl.invalid) return;

    const file = fileControl.value as File;
    this.form.setErrors(null);
    this.uploading = true;
    try {
      await firstValueFrom(this.devicesClient.uploadAnimations({
        data: file,
        fileName: file.name
      }).pipe(withBusy(() => this.busy)));
      this.sideNavRef.close(true);
    } catch (error) {
      this.form.setErrors(error);
    } finally {
      this.uploading = false;
      this.cdr.markForCheck();
    }
  }
}
